import { Component, OnInit, inject } from '@angular/core';
import { GenesisUnitOfWork } from 'app/core/core.module';
import { Dealer, Delivery, OrderLineDetail } from 'app/core/model/entity-model';
import _ from 'lodash';

@Component({
    selector: 'app-delivery-detail',
    templateUrl: './delivery-detail.component.html',
    styleUrls: ['./delivery-detail.component.scss'],
    standalone: false
})
export class DeliveryDetailComponent implements OnInit {
    private uow = inject(GenesisUnitOfWork);
    delivery: Delivery;
    stackNumbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];
    stackSlotCount: number;
    stackSlots: { displayOrder: number; orderLineDetail: any }[] = [];
    dealers: Dealer[];
    dealer: Dealer;
    orderLineDetails: OrderLineDetail[] = [];

    get isStackFull() {
        return (
            !this.stackSlots ||
            _(this.stackSlots)
                .filter((slot) => !!slot.orderLineDetail)
                .valueOf().length >= this.stackSlotCount
        );
    }

    async ngOnInit() {
        this.delivery = this.uow.deliveries.createEntity() as Delivery;
        await this.getDealers();
    }
    hasChanges() {
        return this.uow.hasChanges();
    }

    async getDealers() {
        //TODO: get dealers with deliverable OLDs
        this.dealers = await this.uow.getDealers();
    }

    stackNumberChanged = (e) => {
        const stackSlotCount = e.value;
        if (!stackSlotCount) return;
        this.stackSlotCount = stackSlotCount;

        this.resetEmptySlots();
    };

    dealerValueChanged = async (e) => {
        const dealerId = e.value;
        if (!dealerId) {
            this.orderLineDetails = [];
            return;
        }
        this.dealer = await this.uow.dealers.byId(dealerId) as Dealer;

        //TODO: only get OLDs ready to be shipped
        this.orderLineDetails = await this.uow.getDealerOrderLineDetails(dealerId, 'orderLine.order');
    };

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons',
        });
    }

    addToStack(orderLineDetail: OrderLineDetail) {
        if (!orderLineDetail || this.isStackFull) return;

        const nextSlot = _(this.stackSlots)
            .filter((slot) => !slot.orderLineDetail)
            .orderBy((slot) => slot.displayOrder, 'desc')
            .pop();
        console.log(nextSlot);

        // nextSlot.orderLineDetail.id = orderLineDetail;
        nextSlot.orderLineDetail = { id: orderLineDetail.id, dealer: this.dealer.companyName,  partNumber: orderLineDetail.orderLine.partNumber, vIN: orderLineDetail.vIN }
    }

    onStackReorder = (e) => {
        const visibleRows = e.component.getVisibleRows();
        const toSlot = visibleRows[e.toIndex].data;
        const fromSlot = e.itemData;

        const slotNumber = toSlot.displayOrder;
        toSlot.displayOrder = fromSlot.displayOrder;
        fromSlot.displayOrder = slotNumber;

        this.resetEmptySlots();
    };

    resetEmptySlots() {
        this.stackSlots = _(this.stackSlots)
            .filter((slot) => !!slot.orderLineDetail)
            .orderBy((slot) => slot.displayOrder)
            .valueOf();

        for (let i = 0; i < this.stackSlotCount; i++) {
            const slot = this.stackSlots[i];
            if (slot) slot.displayOrder = i + 1;
            else this.stackSlots.push({ displayOrder: i + 1, orderLineDetail: null });
        }
    }

    complete(){}
}
